import React from 'react';

interface StatCardProps {
    icon: React.ReactNode;
    iconVariant?: 'primary' | 'success' | 'warning' | 'info';
    label: string;
    value: string | number;
    change?: {
        value: string;
        positive: boolean;
    };
}

export const StatCard: React.FC<StatCardProps> = ({
    icon,
    iconVariant = 'primary',
    label,
    value,
    change,
}) => {
    return (
        <div className="stat-card">
            <div className={`stat-icon ${iconVariant}`}>{icon}</div>
            <div className="stat-content">
                <div className="stat-label">{label}</div>
                <div className="stat-value">{value}</div>
                {change && (
                    <div className={`stat-change ${change.positive ? 'positive' : 'negative'}`}>
                        {change.positive ? '↑' : '↓'} {change.value}
                    </div>
                )}
            </div>
        </div>
    );
};
